<template>
  <div class="flex items-center">
    <div class="w-3 rounded-2  mr-7 flex-shrink-0" :class="colorHeight" :style="userColor" />
    <div class=" flex items-center justify-between text-app-color flex-grow">
      <p class="truncate" :class="maxWidth">{{ firstName }} {{ lastName }}</p>
      <slot name="button" />
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import userColorMixin from '@/mixins/userColorMixin'

export default defineComponent({
  props: {
    firstName: String,
    lastName: { type: String, default: '' },
    color: { type: String, default: 'Omolon' },
    colorHeight: { type: String, default: 'h-21' },
    maxWidth: String
  },

  setup (props) {
    const userColor = computed(() => userColorMixin().getColor(props.color))

    return {
      // ref
      // data
      userColor
      // computed
      // function
    }
  }
})
</script>
